import { computed, inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ClinicStore } from "../../../features/admin/state/clinic.store";
import { filter, map, of, take } from "rxjs";
import { toObservable } from "@angular/core/rxjs-interop";
import { ProviderStore } from "../../../features/admin/state/provider.store";

export const getAllClinicsResolver: ResolveFn<any> = (route) => {
    const clinicStore = inject(ClinicStore)
    const providerStore = inject(ProviderStore)
    const cachedList = clinicStore.entities()

    if(cachedList.length > 0 ) return of(true)

    clinicStore.loadClinics()
    providerStore.loadAllProviders()

    return toObservable(
        computed(() => ({
            status: clinicStore.clinicStatus(),
            providerStatus: providerStore.providerStatus(),
            found: clinicStore.entities().length > 0,
            providersFound: providerStore.entities().length > 0
        }))
    ).pipe(
        filter(({status}) => status === 'success' || status === 'error'),
        filter(({providerStatus}) => providerStatus === 'success' || providerStatus === 'error'),
        take(1),
        map(({found, providersFound}) => found && providersFound)
    )
}